import React from 'react';
import { NotifyOutsideClick } from 'core/components';
import { SearchFilter, BaasicButton, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { LookupSelectTemplate } from 'themes/modules/lookup/pages';
import moment from 'moment';
import _ from 'lodash';
import { isSuperAdminOrganization, isWarehouse } from 'core/utils';

const HeaderTemplate = ({
	t,
	currentView: {
		rootStore,
		toggleProfileMenu,
		setProfileMenu,
		profileMenuOpen,
		toggleSyncMenu,
		setSyncMenu,
		syncMenuOpen,
		headerComponents,
		headerComponentTypes,
		toggleModeMenu,
		setModeMenu,
		modeMenuOpen,
		modes,
		isSyncAllowed,
		setActionMenu,
		toggleActionMenu,
		actionMenuOpen,
		loginStore,
		sellerDropdownStore,
		displaySellerDropdown
	},
}) => {
	let locale = window.navigator.userLanguage || window.navigator.language;
	moment.updateLocale('en', {
		longDateFormat: {
			LLL: 'MM/DD/YYYY hh:mm:ss a',
			L: 'MM/DD/YYYY',
		},
	});
	moment.locale(locale);
	return (
		<header className="layout__main__header">
			<div className="header__search">
				{_.map(headerComponents, component => {
					if (!component.active) return null;
					if (component.type === headerComponentTypes.searchComponent) {
						return (
							<div key={'headerComponentTypes.searchComponent'}>
								<SearchFilter
									className="input input--med input--text header__search__filter"
									rootStore={rootStore}
									queryUtility={component.queryUtility}
								/>
							</div>
						);
					}
				})}
			</div>
			{_.map(headerComponents, component => {
				if (!component.active) return null;
				if (component.type === headerComponentTypes.buttonComponent) {
					return (
						<div key={'headerComponentTypes.buttonComponent'} className="header__left--mode">
							<NotifyOutsideClick action={() => setActionMenu(false)}>
								<div className="header__profile" onClick={toggleActionMenu}>
									<div>
										<i className="fa fa-cogs spc--right--tny" />

										<span className="spc--right--tny">{t('ACTIONS')}</span>

										<i className="fa fa-angle-down spc--left--sml" />
									</div>
									<div className={'header__profile--dropdown right' + (actionMenuOpen ? ' active' : '')}>
										<ul>
											{_.map(component.buttonProps.buttons, (button, idx) => {
												return (
													<BaasicButton
														key={'headerComponentTypes.buttonComponent' + idx}
														className={button.className}
														label={t(button.text)}
														onClick={button.onClick}
														icon={button.iconClassName}
														authorization={button.authorization}
													/>
												);
											})}
										</ul>
									</div>
								</div>
							</NotifyOutsideClick>
						</div>
					);
				}
			})}
			<div className="header__right">
				{_.map(headerComponents, (component, idx) => {
					if (!component.active) return null;
					if (component.type === headerComponentTypes.miscComponent) {
						return (
							<React.Fragment key={idx}>
								<LookupSelectTemplate {...component.componentData.props} />
							</React.Fragment>
						);
					}
				})}


				{modes && modes.length != 0 ? (
					<div className="header__right--mode">
						<NotifyOutsideClick action={() => setModeMenu(false)}>
							<div className="header__profile" onClick={toggleModeMenu}>
								<div>
									<span className="spc--right--tny">{t('MODE')}</span>

									<i className="fa fa-angle-down spc--left--med" />
								</div>
								<div className={'header__profile--dropdown' + (modeMenuOpen ? ' active' : '')}>
									<ul>
										{_.map(modes, mode => {
											return (
												<li key={mode.id} className="header__profile--dropdown__item" onClick={mode.onClick}>
													{t(mode.name)}
												</li>
											);
										})}
									</ul>
								</div>
							</div>
						</NotifyOutsideClick>
					</div>
				) : null}

				{displaySellerDropdown && (isSuperAdminOrganization(rootStore) || isWarehouse(rootStore)) &&
				 <div className="header__right--seller">
					 <BaasicDropdown
						 dropdownStore={sellerDropdownStore}
						 placeholder={t('PLACEHOLDER.SELLER')}
						 isClearable={true}
						 className="w--200--px spc--right--sml"
				 	/>
				 </div>
				}

				{rootStore.applicationStore.currentOrganization && isSyncAllowed ? (
					<div className="header__right--sync">
						<NotifyOutsideClick action={() => setSyncMenu(false)}>
							<div className="header__profile" onClick={toggleSyncMenu}>
								<div>
									<i className="fa fa-sync spc--right--tny" />
									<i className="fa fa-angle-down spc--left--med" />
								</div>
								<div className={'header__profile--dropdown' + (syncMenuOpen ? ' active' : '')}>
									<ul>
										<li>
											<button
												type="submit"
												className="btn btn--med btn--primary w--100"
												onClick={rootStore.viewStore.syncAllOrders}
												disabled={rootStore.viewStore.syncInProgress}
											>
												{rootStore.viewStore.syncInProgress && rootStore.viewStore.syncAllInProgress ? (
													<div className="spinnercont spc--right--sml">
														<div className="spinner"></div>
													</div>
												) : (
													<div>{t('SYNCHRONISEALLCHANNELS')} </div>
												)}
											</button>
										</li>
										{_.map(rootStore.viewStore.channels, channel => {
											if (channel.channelType.abrv != 'manual%20orders') {
												return (
													<li key={channel.id} className="sync">
														<div className="sync--main">
															<div className="sync--main__item" aria-label={channel.name}>
																{channel.name}
															</div>
															<small>
																<span>Last update: </span>
																<span>
																	{channel.lastSyncRealTime
																		? moment
																				.utc(channel.lastSyncRealTime)
																				.toDate()
																				.toLocaleString()
																				.replace(/,/g, '')
																		: ' -'}
																</span>
															</small>
														</div>
														<div className="sync--aside">
															<button
																type="submit"
																className="btn btn--med btn--primary"
																onClick={() => rootStore.viewStore.syncChannelOrders(channel)}
																disabled={rootStore.viewStore.syncInProgress}
															>
																{rootStore.viewStore.syncInProgress &&
																channel.id == rootStore.viewStore.loadingChannelId ? (
																	<div className="spinnercont">
																		<div className="spinner"></div>
																	</div>
																) : (
																	<i className="fa fa-sync" />
																)}
															</button>
														</div>
													</li>
												);
											}
										})}
									</ul>
								</div>
							</div>
						</NotifyOutsideClick>
					</div>
				) : null}

				<div className="header__right--profile">
					<NotifyOutsideClick action={() => setProfileMenu(false)}>
						<div className="header__profile" onClick={toggleProfileMenu}>
							<div>
								<i className="fa fa-user spc--right--tny" />
								{rootStore.authStore.user ? rootStore.authStore.user.displayName : ''}
								<i className="fa fa-angle-down spc--left--med" />
							</div>
							<div className={'header__profile--dropdown' + (profileMenuOpen ? ' active' : '')}>
								<ul>
									<li
										className="header__profile--dropdown__item"
										onClick={() => {
											loginStore.logout();
										}}
									>
										{t('LOGOUT')}
									</li>
								</ul>
							</div>
						</div>
					</NotifyOutsideClick>
				</div>
			</div>
		</header>
	);
};

export default defaultTemplate(HeaderTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/HeaderTemplate.jsx